import {
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import useActivity from "./useActivity";
import EmptyData from "../../../Global/EmptyData";
import OrderColumn from "../../../Global/OrderColumn";

const Activity = () => {
  const {
    isLoading,
    isFetching,
    activityData,
    showEditModal,
    activityState,
    paginationOptions,
    handleEditColumnsClick,
    updateActivityTableHead,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useActivity();

  return (
    <>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={activityState?.search === "" ? false : true}
          handleClear={handleClearClick}
          handleActionClick={handleEditColumnsClick}
          searchInputProps={{ value: activityState?.search }}
          showActions={true}
        />
        {activityData?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={activityData?.data?.result || []}
            uniqueID={"id"}
            fields={activityData?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={activityState?.clearSelection}
            perpage={activityState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={activityData?.data?.fields || []}
              moduleId={activityData?.data?.module_id}
              updateData={updateActivityTableHead}
            />
          </div>
        </ModalLayout>

        {activityData?.data?.result?.length > 0 && (
          <Pagination
            currentPage={activityState?.currentPage}
            totalPageCount={Math.ceil(
              activityData.data.total_count / activityState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === activityState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
      </div>
    </>
  );
};

export default Activity;
